/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSettingsPageDetails} from '../api'

 export const useQueryGetSettingsPageDetails = createReactQueryHook('getSettingsPageDetails', getSettingsPageDetails)
